import React from "react";

const HeaderComponent = ({ title }) => {
  return (
    <div className="flex flex-row justify-between items-center bg-[#95C11F]">
      <img
        src={require(`../assets/images/logo-navbar.png`)}
        alt=""
        className="w-[125px] h-[44px] my-4"
      />
      <span className="mr-4 text-2xl text-[#FFFFFF] font-bold">{title}</span>
    </div>
  );
};

export default HeaderComponent;
